import { ImageLibrary } from './image-library.model';

export class ImageLibraryCommand {
    id: string;
    config_key: string;
    config_value: { app_id: string; my_images: boolean; tenant_library: boolean; unsplash: boolean };

    constructor(imageLibrary: ImageLibrary) {
        this.id = imageLibrary.id;
        this.config_key = imageLibrary.configKey;
        this.config_value = imageLibrary.configVal;
    }
}
